import type { Segment } from "../types"
import type { CompanyDirectoryEntry, ConnectionRole } from "./segment-connections"

const nameKey = (name: string) => name.trim().toLowerCase()

/**
 * How `companyName` relates to ONE segment — the role a drill-in from that
 * segment should open (customer → Customer Centric Plan, competitor → Competitor
 * Plan). Customers win when a company is listed as both, matching the map edge
 * role (customers are laid out first). `null` when the company isn't listed.
 */
export function companyRoleInSegment(
  segment: Pick<Segment, "customers" | "competitors"> | null | undefined,
  companyName: string
): ConnectionRole | null {
  if (!segment) return null
  const key = nameKey(companyName)
  if (!key) return null
  if (segment.customers.some((name) => nameKey(name) === key)) return "customer"
  if (segment.competitors.some((name) => nameKey(name) === key)) return "competitor"
  return null
}

/**
 * The segment a related-company drill-in should open in: the current drill-in's
 * segment when the related company is also in it (so the plan opens in the same
 * context), otherwise the related company's first segment.
 */
export function relatedCompanySegmentId(
  entry: Pick<CompanyDirectoryEntry, "segments">,
  preferSegmentId?: string | null
): string | null {
  if (preferSegmentId && entry.segments.some((segment) => segment.id === preferSegmentId)) {
    return preferSegmentId
  }
  return entry.segments[0]?.id ?? null
}
